import { render, staticRenderFns } from "./EmailLogin.vue?vue&type=template&id=958fbc1a&scoped=true&"
import script from "./EmailLogin.vue?vue&type=script&lang=js&"
export * from "./EmailLogin.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogin.vue?vue&type=style&index=0&id=958fbc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958fbc1a",
  null
  
)

export default component.exports